import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { FrameworkKindFilter, FrameworkListFilters, FrameworkStatusFilter } from './models';

export const ratingMatrixFrameworkListInitialState: FrameworkListFilters = {
  search: '',
  status: 'all',
  kind: 'all',
  includeArchived: false,
  selectedSectorId: null,
};

export const ratingMatrixFrameworkListSlice = createSlice({
  name: 'ratingMatrixFrameworkList',
  initialState: ratingMatrixFrameworkListInitialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setStatus(state, action: PayloadAction<FrameworkStatusFilter>) {
      state.status = action.payload;
    },
    setKind(state, action: PayloadAction<FrameworkKindFilter>) {
      state.kind = action.payload;
    },
    setIncludeArchived(state, action: PayloadAction<boolean>) {
      state.includeArchived = action.payload;
    },
    setSelectedSectorId(state, action: PayloadAction<number | null>) {
      state.selectedSectorId = action.payload;
    },
    resetFilters() {
      return ratingMatrixFrameworkListInitialState;
    },
  },
});

export const {
  setSearch,
  setStatus,
  setKind,
  setIncludeArchived,
  setSelectedSectorId,
  resetFilters,
} = ratingMatrixFrameworkListSlice.actions;

export const selectFrameworkListFilters = (state: {
  ratingMatrixFrameworkList: FrameworkListFilters;
}) => state.ratingMatrixFrameworkList;
